import { createAsyncThunk } from '@reduxjs/toolkit';
import * as AccountsClient from '../data/api/AccountsClient';
export const fetchAccounts = createAsyncThunk('fetchAccounts', () => {
  return AccountsClient.fetchAccounts();
});
export const fetchAccountById = createAsyncThunk('fetchAccountById', () => {
  return AccountsClient.fetchAccountById();
});